import svgIconArrowLeft from '../icons/icon-arrow-left.svg'
import svgIconArrowRight from '../icons/icon-arrow-right.svg'

export default class Pagination {
    static init() {
        const block = document.querySelector('.pagination')

        if (block) {
            new Pagination(block)
        }
    }

    constructor(block) {
        console.log('Pagination-svg')
        const iconArrowLeft = block.querySelectorAll('.icon-arrow-left')
        const iconArrowRight = block.querySelectorAll('.icon-arrow-right')

        if (iconArrowLeft) {
            iconArrowLeft.forEach(icon => {
                icon.insertAdjacentHTML('afterbegin', svgIconArrowLeft)
            })
        }

        if (iconArrowRight) {
            iconArrowRight.forEach(icon => {
                icon.insertAdjacentHTML('afterbegin', svgIconArrowRight)
            })
        }
    }
}
